/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../ticket/ticket.component.ngfactory';
import * as import2 from '../ticket/ticket.component';
import * as import3 from '../../identity/identity.model';
import * as import4 from '../../orchestration/responsive.service';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from 'ng2-translate/src/translate.service';
import * as import7 from '../loyalty-card/loyalty-card.component.ngfactory';
import * as import8 from '../loyalty-card/loyalty-card.component';
import * as import9 from '@angular/common';
import * as import10 from './loyalty-cards-page.component';
import * as import11 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import12 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import13 from '../../orchestration/page';
import * as import14 from '../../buttons/link/link.component.ngfactory';
import * as import15 from '../../buttons/link/link.component';
import * as import16 from '../../ordering-context/ordering-context.model';
import * as import17 from '../../deal/deal.model';
import * as import18 from '../../ui-elements/loading/loading.service';
import * as import19 from '../../orchestration/analytics.service';
import * as import20 from '../../notification/notification.service';
const styles_LoyaltyCardsPageComponent:any[] = ([] as any[]);
export const RenderType_LoyaltyCardsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LoyaltyCardsPageComponent,
  data: {}
}
);
function View_LoyaltyCardsPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ticket',[[
        'class',
        'cards-card'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),import1.View_TicketComponent_0,import1.RenderType_TicketComponent)),
    import0.ɵdid(245760,(null as any),0,import2.TicketComponent,[
      import3.IdentityModel,
      import0.ChangeDetectorRef,
      import4.ResponsiveService,
      import5.NavigationService,
      import6.TranslateService
    ]
    ,{
      ticket: [
        0,
        'ticket'
      ]
      ,
      index: [
        1,
        'index'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit;
    const currVal_2:any = v.context.index;
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'ticket-',v.context.index,'');
    ck(v,0,0,currVal_0);
  });
}
function View_LoyaltyCardsPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-loyalty-card',[[
        'class',
        'cards-card'
      ]
      ],[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'onRedeem'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onRedeem' === en)) {
        const pd_0:any = ((<any>co.redeemCard(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import7.View_LoyaltyCardComponent_0,import7.RenderType_LoyaltyCardComponent)),
    import0.ɵdid(245760,(null as any),0,import8.LoyaltyCardComponent,[
      import0.ChangeDetectorRef,
      import4.ResponsiveService,
      import3.IdentityModel
    ]
    ,{
      card: [
        0,
        'card'
      ]
      ,
      index: [
        1,
        'index'
      ]

    }
    ,{onRedeem: 'onRedeem'})
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit;
    const currVal_2:any = v.context.index;
    ck(v,1,0,currVal_1,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'loyalty-card-',v.context.index,'');
    ck(v,0,0,currVal_0);
  });
}
function View_LoyaltyCardsPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'cards'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardsPageComponent_2)),
    import0.ɵdid(802816,(null as any),0,import9.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardsPageComponent_3)),
    import0.ɵdid(802816,(null as any),0,import9.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.tickets;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.loyaltyCards;
    ck(v,6,0,currVal_1);
  },(null as any));
}
export function View_LoyaltyCardsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'woa-modal-page-layout',([] as any[]),(null as any),[[
        (null as any),
        'onRefresh'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.LoyaltyCardsPageComponent = v.component;
      if (('onRefresh' === en)) {
        const pd_0:any = ((<any>co.loadMemberSummary()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import11.View_ModalPageLayoutComponent_0,import11.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import12.ModalPageLayoutComponent,[
      import13.Page,
      import5.NavigationService
    ]
    ,{
      showRefreshButton: [
        0,
        'showRefreshButton'
      ]
      ,
      title: [
        1,
        'title'
      ]
      ,
      contentText: [
        2,
        'contentText'
      ]

    }
    ,{onRefresh: 'onRefresh'}),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import13.PageLayout,(null as any),[import12.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_LoyaltyCardsPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,1,'woa-link',[[
        'class',
        'view-profile'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.LoyaltyCardsPageComponent = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.profile()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_LinkComponent_0,import14.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import15.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.LoyaltyCardsPageComponent = v.component;
    const currVal_0:any = true;
    const currVal_1:any = 'woa.heading.loyalty-cards.title';
    const currVal_2:any = co.contentText;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = co.showCards;
    ck(v,8,0,currVal_3);
    const currVal_4:any = 'woa.button.loyalty-cards.viewProfile';
    ck(v,11,0,currVal_4);
  },(null as any));
}
function View_LoyaltyCardsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-loyalty-cards-page',([] as any[]),(null as any),(null as any),(null as any),View_LoyaltyCardsPageComponent_0,RenderType_LoyaltyCardsPageComponent)),
    import0.ɵdid(114688,(null as any),0,import10.LoyaltyCardsPageComponent,[
      import16.OrderingContextModel,
      import3.IdentityModel,
      import17.DealModel,
      import18.LoadingService,
      import0.ChangeDetectorRef,
      import5.NavigationService,
      import19.AnalyticsService,
      import20.NotificationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import13.Page,(null as any),[import10.LoyaltyCardsPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const LoyaltyCardsPageComponentNgFactory:import0.ComponentFactory<import10.LoyaltyCardsPageComponent> = import0.ɵccf('woa-loyalty-cards-page',import10.LoyaltyCardsPageComponent,View_LoyaltyCardsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/loyalty-card/loyalty-cards-page/loyalty-cards-page.component.ngfactory.ts